import {Directive, ElementRef, EventEmitter, OnDestroy, OnInit, Output} from "@angular/core";
import * as ResizeSensor from "css-element-queries/src/ResizeSensor";

@Directive({
	selector: "[elementResized]",
})
/**
 * Provides an `(elementResized)` event that fires when the size of an element changes for any
 * reason.
 */
export class ElementResizedDirective implements OnInit, OnDestroy {
	@Output() elementResized = new EventEmitter<{type: string, target: Element}>();

	private resizeSensor: ResizeSensor;
	private callback: () => void;

	constructor(private elementRef: ElementRef) { }

	ngOnInit() {
		// Assign the function to the instance rather than the prototype because we need to bind the
		// this value AND preserve a reference to the function so we can detach it later.
		this.callback = () => {
			let event = {
				type: "elementResized",
				target: this.elementRef.nativeElement as Element,
			};
			this.elementResized.emit(event);
		};

		this.resizeSensor = new ResizeSensor(this.elementRef.nativeElement, this.callback);
	}

	ngOnDestroy() {
		if (this.resizeSensor != null) {
			this.resizeSensor.detach(this.callback);
		}
	}
}
